import _get from 'lodash/get';
import _map from 'lodash/map';
import initialState from './initialState';
import actionType from './actionType';

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
            };
        case actionType.GET_USER_INFO_SUCCESS: {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    ...action.payload,
                },
            };
        }
        case actionType.GET_USER_DETAILS_SUCCESS: {
            return {
                ...state,
                userDetails: action.payload,
            };
        }
        case actionType.LOGIN_FAILURE: {
            return {
                ...state,
                error: {
                    isOpen: true,
                    message: 'Invalid Login Credentials',
                },
            };
        }
        case actionType.GET_ALL_EN_USERS_SUCCESS: {
            return {
                ...state,
                userData: action.payload,
            };
        }
        case actionType.GET_ALL_EN_ROLES_SUCCESS: {
            return {
                ...state,
                roleData: action.payload,
            };
        }
        case actionType.GET_ALL_EN_APPLICATIONS_SUCCESS: {
            return {
                ...state,
                applicationConfigurations: action.payload,
            };
        }
        case actionType.GET_ALL_EN_DASHBOARD_SUCCESS: {
            return {
                ...state,
                dashboardConfigurations: action.payload,
            };
        }
        case actionType.GET_ALL_EN_ROUTES_SUCCESS: {
            return {
                ...state,
                routesConfigurations: action.payload,
            };
        }
        case actionType.SET_ARRAY_SUCCESS: {
            return {
                ...state,
                onChangeCaptureRoutesConfiguration: action.payload,
            };
        }
        case actionType.UPDATE_ONCHANGE_CAPTURE_ROUTE_PERMISSIONS: {
            return {
                ...state,
                onChangeCaptureRoutePermissions: action.payload,
            };
        }
        case actionType.GET_APPLICATION_SCREEN_PERMISSION_SUCCESS: {
            const screenPermissions = [];
            action.payload.map((data) => {
                data.screen_permissions &&
                    data.screen_permissions.map((itm) => {
                        const permissions = _map(screenPermissions, 'title').toString();
                        if (permissions.includes(itm.title)) {
                            const pushedData = screenPermissions.find((data) => data.title === itm.title);
                            const pushedDataIndex = screenPermissions.findIndex((data) => data.title === itm.title);
                            if (pushedData && !pushedData.isActionEnabled) {
                                screenPermissions.splice(pushedDataIndex, 1);
                                screenPermissions.push(itm);
                            }
                        } else {
                            screenPermissions.push(itm);
                        }
                    });
            });
            return {
                ...state,
                screenPermissions: screenPermissions,
            };
        }
        case actionType.GET_ALL_ACTIVITY_LOGS: {
            return {
                ...state,
                userActivityLogs: action.payload,
            };
        }
        case actionType.GET_ALL_ROLES_DASHBOARD: {
            return {
                ...state,
                allRolesDashboard: action.payload,
            };
        }
        default:
            return state;
    }
};

export default usersReducer;
